<div class="progress-dialog">
  <span class="fa fa-exclamation-circle"></span>
  <div class="message" [innerHTML]="message"></div>
  <mat-progress-bar class="bar" [mode]="'determinate'" [value]="progressValue"> </mat-progress-bar>
  <div class="count">{{ currentProgress }} von {{ progressGoal }}</div>
</div>
